// import React, { useEffect, useState } from "react";
// import Axios from "../../../services/AxiosInstance";
import { useNavigate } from 'react-router-dom';
import Notification from "../../Notification";


import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";

import ReactPaginate from 'react-paginate';

// import Notification from "../Notification";
// import { Link } from "@material-ui/core";




const ContactsCostList = () => {
    // const [serviceName, setServiceName] = useState('');
    // const [editName, setEditName] = useState(false);
    // const [serviceId, setServiceId] = useState('1');

    // const Navigate = useNavigate();
    const [contactsCost_details, setContactsCostDetails] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [sortToggle,setSortToggle] = useState(true);
    
    const [perPage,setPerpage] = useState(2);
    
    const [searchData, setSearchData] = useState('');

    const [once,setOnce] =useState([]);




    const gecontactsCostList = async () => {
        let res;
        if(searchData)
        {
        res = await Axios.get(`api/business/contacts-cost-list?searchData=${searchData}`);
        console.log(res);
        }
        else{
            res = await Axios.get(`api/business/contacts-cost-list?pageNo=1&perPage=${perPage}`);
        }
        console.log(res);
        setContactsCostDetails (res.data.data);
        console.log(contactsCost_details);
        setTotalPage(res.data.data.totalPage);
        setpageCount(res.data.data.totalPage);
        console.log(totalPages,pageCount);
        localStorage.removeItem('sort_key');
        localStorage.removeItem('sort_order');
    };

    useEffect(() => {
        gecontactsCostList();
    },[perPage]);



    const fetchContactsCostList = async (currentPage) => {
        const sort_key = localStorage.getItem('sort_key');
        const sort_order = localStorage.getItem('sort_order');
        let sortUrl = "";
        if(sort_key && sort_order){
            sortUrl = `&sortkey=${sort_key}&order=${sort_order}`;
        }
        const res = await Axios.get(`api/business/contacts-cost-list?pageNo=${currentPage}&perPage=${perPage}${sortUrl}`);
        await setContactsCostDetails(res.data.data.data);
        return contactsCost_details;
    };


    const handlePageClick = async (data) => {
        let currentPage = data.selected +1;
        await fetchContactsCostList(currentPage);
    };





    const handleChange = (e) => {
        const { name, checked } = e.target;
        // console.log(name);


        if (name === "allSelect") {
             let tempUser = contactsCost_details.map((plan) => {
                return { ...plan, isChecked: checked };
            });
            console.log(tempUser);
            setContactsCostDetails(tempUser);
        }
        else {
            let tempUser = contactsCost_details.map((plan) =>
                plan.contacts_range_id === name ? { ...plan, isChecked: checked } : plan
            );
            console.log(tempUser);
            setContactsCostDetails(tempUser);
        }
    }



    // const handleChange = (e) => {
    //     const { name, checked } = e.target;
    //     // console.log(name);


    //     if (name === "allSelect") {
    //          let tempUser = package_details.map((plan) => {
    //             return { ...plan, isChecked: checked };
    //         });
    //         console.log(tempUser);
    //         setPackageDetails(tempUser);
    //     }
    //     else {
    //         let tempUser = package_details.map((plan) =>
    //             plan.service_id === name ? { ...plan, isChecked: checked } : plan
    //         );
    //         console.log(tempUser);
    //         setPackageDetails(tempUser);
    //     }
    // }





    // function HandleEditName(e) {
    //     console.log(e.target.value);
    //     setServiceId(e.target.value);
    //     console.log(buyContacts_details.length);
    //     for (let i = 0; i < buyContacts_details.length; i++) {
    //         if (buyContacts_details[i].service_id === e.target.value) {
    //             setServiceName(buyContacts_details[i].service_name);
    //         }
    //     }
    //     setEditName(true);
    // }








    const DeleteApi = (e) => {
        const contactsCostIds = [];
        if (e.target.value) {
            contactsCostIds.push(e.target.value);
        }
        for (let i = 0; i < contactsCost_details.length; i++) {
            if (contactsCost_details[i].isChecked === true) {
                contactsCostIds.push(contactsCost_details[i].contacts_range_id);
            }
        }
        console.log(contactsCostIds);
        Axios
            .post("api/bussiness/created-contact-plan-deleted", {
                contacts_range_ids: contactsCostIds
            }).then((res) => {
                console.log(res);
                window.location.reload(false);
            }).catch((error) => {
                console.log(error);
            })

    }



    // const DeleteApi = (e) => {
    //     console.log(package_details);
    //     const packageIds = [];
    //     if (e.target.value) {
    //         packageIds.push(e.target.value);
    //     }
    //     // console.log('hi',package_details[0].package_id);
    //     for (let i = 0; i < package_details.length; i++) {
    //         if (package_details[i].isChecked === true) {
    //             packageIds.push(package_details[i].package_id);
    //         }
    //     }
    //     console.log("hi",packageIds);
    //     Axios
    //         .post("api/bussiness/package-delete", {
    //             packageIdsArr: packageIds
    //         }).then((res) => {
    //             console.log(res);
    //             window.location.reload(false);
    //         }).catch((error) => {
    //             console.log(error);
    //         })

    // }







    const contactsCostListing = contactsCost_details.map((plan, index) => {
        return (
            <tr key={index} value = {plan.contacts_range_id}>
                <td><input
                    type="checkbox"
                    name={plan.contacts_range_id}
                    checked={plan?.isChecked || false}
                    onChange={handleChange}
                />
                </td>
                <td>{index + 1}</td>
                <td>{plan.total_contacts}</td>
                <td>{plan.contacts_range_id}</td>
                <td>{plan.cost_per_contacts}</td>
                <td>{plan.status}</td>
                <td >
                    <button className='delet-btn' value={plan.contacts_range_id} onClick={(e) => DeleteApi(e)}>Delete</button>
                </td>
            </tr>
        )
    })


    const handleSortdesc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey,order);
            // alert('I am Decending')
            setSortToggle(true);
            localStorage.setItem("sort_key", sortkey);
            localStorage.setItem("sort_order", order);
            const res = await Axios.get(`api/bussiness/service-listing?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setContactsCostDetails(res.data.data.data);
                // setSortToggle(true);
            }
        }
    }



    const handleSortasc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey)
            // alert('I am accending')
            setSortToggle(false);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/bussiness/service-listing?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setContactsCostDetails(res.data.data.data);
            }
        }
    }



    return (
        <>
            <div className="content-page">
                <div className="content">


                    <div className="container-fluid">


                    <div  className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Techzoni</a></li>
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Forms</a></li>
                                            <li className="breadcrumb-item active">Form Validation</li>
                                        </ol>
                                    </div>
                                    <h4 className="page-title">Contacts List</h4>
                                </div>
                            </div>
                     </div>

                     <div style={{ position: "absolute", right: "30px" }}>
                            </div>
                        
                            <div className="col-md-6 col-xl-3">
                                <div className="card-box">
                                    <div className="form-group mb-0 text-center">
                                        <input type="" className='search-product-box' placeholder='Search...'
                                            onChange={(e) => setSearchData(e.target.value)}
                                        />

                                        <button>Search</button>
                                    </div>
                                </div>
                                
                            </div>




                        <div className="row">
                            <div className="card-box table-responsive">
                                <h4 className="header-title"><b>Contacts Plan</b></h4>
                                {/* <!-- <p className="sub-header">
                                            Show Listing</code>.
                                        </p> --> */}
                                <button className='all-delete' onClick={DeleteApi}>All Delete</button>
                                {
                                    totalPages === 0 ?
                                        <h1>Data Not found</h1>
                                        :
                                <table id="datatable" className="table table-bordered  dt-responsive nowrap">
                                    <thead>
                                        <tr>
                                            <td><input
                                                type="checkbox"
                                                name="allSelect"
                                                checked={!contactsCost_details.some((plan) => plan?.isChecked !== true)}
                                                onChange={handleChange}
                                            />allSelect
                                            </td>
                                            <td>S.No</td>
                                            <td >Contacts Range
                                            {sortToggle ? (
                                                        <i onClick={() => handleSortasc("service_name", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("service_name", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                            </td>
                                            <td>Contacts Range Id
                                            {sortToggle ? (
                                                        <i onClick={() => handleSortasc("service_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("service_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                            </td>
                                            <td>Cost Per Contacts (in Rupees)
                                            {sortToggle ? (
                                                        <i onClick={() => handleSortasc("added_by", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("added_by", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                            </td>
                                            <td>Status
                                            {sortToggle ? (
                                                        <i onClick={() => handleSortasc("added_date", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("added_date", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                            </td>
                                            <td>Action</td>
                                        </tr>
                                    </thead>


                                    <tbody>

                                        {contactsCostListing}

                                    </tbody>

                                </table>
                            }
                                <ReactPaginate
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    breakLabel={"..."}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination justify-content-center"}
                                    pageClassName={"page-item"}
                                    pageLinkClassName={"page-link"}
                                    previousClassName={"page-item"}
                                    previousLinkClassName={"page-link"}
                                    nextClassName={"page-item"}
                                    nextLinkClassName={"page-link"}
                                    breakClassName={"page-item"}
                                    breakLinkClassName={"page-link"}
                                    activeClassName={"active"}
                                />
                                <span><b>Rows per page:-</b></span>
                                        <select name="Rows per page" onChange={(e) => setPerpage(e.target.value)}>
                                            <option>Select Per Page</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="40">40</option>
                                            <option value="50">50</option>
                                            <option value="60">60</option>
                                        </select>
                            </div>

                        </div>

                    </div>
                </div>


            </div>

        </>

    )
}

export default ContactsCostList;